import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { AsignarCamionSucursalModal, AsignarCamionSucursalModel } from "./sucursal";


const SucursalButton = kea.defaultProps(kea.Button, { children: "Asignar a sucursal", iconClass: fa("map-marker") });

export class MovimientoCamionindex extends React.PureComponent {
    modalManager = kea.createModalManager();

    onAsignarSucursal = async () => {
        const result = await this.modalManager.showModal(AsignarCamionSucursalModal, undefined, {} as AsignarCamionSucursalModel);
        if (result.result) {
            const model = result.value;
            await resources.Camion.AsignarSucursal(model.idCamion, model.idSucursal);
        }
    }

    render() {
        return (
            <div>
                <div className="btn-group" >
                    <SucursalButton onClick={this.onAsignarSucursal} />
                </div>

                {this.modalManager.component}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscamion/edit/index.tsx